import * as HttpService from 'services/http.service';
import { CONTACT_US_FORM_API_URL } from 'services/url.service';

const contactUsFormAPI = ({ data }) =>
  HttpService.postWithAuth(CONTACT_US_FORM_API_URL(), data);

const contactHaflaForm = async ({ data, setLoading, setShowToast }) => {
  setLoading(true);
  try {
    const { status } = await contactUsFormAPI({ data });
    setShowToast({
      message: status
        ? 'Message sent successfully'
        : 'Message not sent, something went wrong',
      show: true,
      successToast: status
    });
  } catch (error) {
    setShowToast({ show: true, successToast: false, message: error.message });
  } finally {
    setLoading(false);
  }
};

export default contactHaflaForm;
